// extracted by mini-css-extract-plugin
export var cardContainer = "CardFilledView-module--cardContainer--FYbYb";
export var card = "CardFilledView-module--card--w7tZD";
export var cardOpen = "CardFilledView-module--cardOpen--iAKdB";
export var cardOpenPrompt = "CardFilledView-module--cardOpenPrompt--fLrXy";
export var cardPanel = "CardFilledView-module--cardPanel--LSmEN";
export var cardPanelFront = "CardFilledView-module--cardPanelFront--wMUjO";
export var cardPanelBack = "CardFilledView-module--cardPanelBack--G0mVq";
export var pulseRing = "CardFilledView-module--pulse-ring--Z6D0U";
export var pulseDot = "CardFilledView-module--pulse-dot--skM09";